import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => {
    history.pushState(null, null, document.URL)
  },
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('./components/login.vue')
    },
    {
      path:'/layout',
      name: 'Layout',
      component: () => import('./components/layout.vue')
    },
    {
      path: '/main',
      name: 'Main',
      component: () => import('./components/main.vue')
    },
    {
      path: '/deviceLogin', //设备登录
      name: 'DeviceLogin',
      component: () => import('./components/deviceLogin.vue'),
      meta: { title: '设备登录', icon: '设备登录' },
    },
    {
      path: '/appMarket', //应用市场
      name: 'AppMarket',
      component: () => import('./components/AppMarket/index.vue'),
      meta: { title: '应用市场', icon: '应用市场' },
    },
    {
      path: '/deviceManage', //设备管理
      name: 'DeviceManage',
      component: () => import('./components/device.vue')
    },
    //先隐藏
    // {
    //   path: '/orderList', //订单列表
    //   name: 'OrderList',
    //   component: () => import('./components/order/index.vue'),
    //   meta: { title: '订单列表', icon: '订单列表' },
    // },
  ]
})
